












































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { User } from "@/modules/auth/types";
import { Business } from "@/modules/businesses/types";

const Auth = namespace("auth");
const BusinessNamespace = namespace("business");

@Component({})
export default class Sidebar extends Vue {
  @Auth.Getter("getUser") user!: User;
  @BusinessNamespace.Getter("getSelectedBusiness") selectedBusiness: Business;

  isAdmin(allowDevelopers) {
    // 0 = Admin, 1 = Developer
    if (allowDevelopers) return this.user.role === 0 || this.user.role === 1 || this.user.role === 3;
    else return this.user.role === 0 || this.user.role === 3;
  }
}
